import { fabric } from 'fabric';

function isTransformCentered(transform) {
  return transform.originX === 'center' && transform.originY === 'center';
}

const internalChangeWidthAndHeight = (eventData, transform, x, y) => {
  const target = transform.target;
  const localPoint = fabric.controlsUtils.getLocalPoint(
    transform,
    transform.originX,
    transform.originY,
    x,
    y
  );
  const strokeXPadding =
    target.strokeWidth / (target.strokeUniform ? target.scaleX : 1);
  const strokeYPadding =
    target.strokeWidth / (target.strokeUniform ? target.scaleY : 1);
  const multiplier = isTransformCentered(transform) ? 2 : 1;

  const oldWidth = target.width;
  const newWidth =
    Math.abs((localPoint.x * multiplier) / target.scaleX) - strokeXPadding;
  target.set('width', Math.max(newWidth, 0));

  const oldHeight = target.height;
  const newHeight =
    Math.abs((localPoint.y * multiplier) / target.scaleY) - strokeYPadding;
  target.set('height', Math.max(newHeight, 0));

  return oldWidth !== newWidth || oldHeight !== newHeight;
};

const changeHeightInternal = (eventData, transform, x, y) => {
  const target = transform.target;
  const localPoint = fabric.controlsUtils.getLocalPoint(
    transform,
    transform.originX,
    transform.originY,
    x,
    y
  );

  const strokeYPadding =
    target.strokeWidth / (target.strokeUniform ? target.scaleY : 1);
  const multiplier = isTransformCentered(transform) ? 2 : 1;

  const oldHeight = target.height;
  const newHeight =
    Math.abs((localPoint.y * multiplier) / target.scaleY) - strokeYPadding;
  target.set('height', Math.max(newHeight, 0));

  return oldHeight !== newHeight;
};

// A fabric.controlUtils variant that changes the width and height of an object
// rather than the scale. This works, but is undesirable for any object that
// can be in a group since groups work by changing the scale of the their
// contents - so the shape still needs to handle scale correctly.
const changeWidthAndHeight = fabric.controlsUtils.wrapWithFireEvent(
  'resizing',
  fabric.controlsUtils.wrapWithFixedAnchor(internalChangeWidthAndHeight)
);

const changeHeight = fabric.controlsUtils.wrapWithFireEvent(
  'resizing',
  fabric.controlsUtils.wrapWithFixedAnchor(changeHeightInternal)
);

export { changeHeight, changeWidthAndHeight };
